import classNames from "classnames"

export const EditorButton = ({image, action}) => {
    return (
        <button className={classNames("tr-btn","e-btn")} onClick={action}>
            <img className="e-btn-img" src={image} alt="" />
        </button>
    )
}